import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DonutChartData } from '../donut-chart/donut-chart-data';

@Component({
  selector: 'app-fund-allocation-visualization',
  templateUrl: './fund-allocation-visualization.component.html',
  styleUrls: ['./fund-allocation-visualization.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class FundAllocationVisualizationComponent {
  @Input() donutChartData: DonutChartData[] = [];
  @Input() backgroundColor: string = '#FFFFFF';
  @Input() borderColor: string = '#CACACA';
  @Input() label: string = '';
}
